module.exports = __webpack_public_path__ + "img/no-data.466d89cd.png";